import { useState, useCallback } from "react";
import { NotificationType } from "../components/Notification";

interface Notification {
  id: string;
  message: string;
  type: NotificationType;
}

export function useNotification() {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const addNotification = useCallback(
    (message: string, type: NotificationType = "info") => {
      const id = Date.now().toString() + Math.random().toString(36);
      setNotifications((prev) => [...prev, { id, message, type }]);
      return id;
    },
    [],
  );

  const removeNotification = useCallback((id: string) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }, []);

  const success = useCallback(
    (message: string) => addNotification(message, "success"),
    [addNotification],
  );

  const error = useCallback(
    (message: string) => addNotification(message, "error"),
    [addNotification],
  );

  const info = useCallback(
    (message: string) => addNotification(message, "info"),
    [addNotification],
  );

  const warning = useCallback(
    (message: string) => addNotification(message, "warning"),
    [addNotification],
  );

  return {
    notifications,
    addNotification,
    removeNotification,
    success,
    error,
    info,
    warning,
  };
}
